module.exports = __webpack_public_path__ + "img/column.4e9cb994.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/BI/column.png
// module id = 1767
// module chunks = 137